import {
  UnstyledButton as MantineUnstyledButton,
  UnstyledButtonProps,
  createPolymorphicComponent,
} from '@mantine/core';
import React from 'react';

export type IUnstyledButtonProps = UnstyledButtonProps;

const UnstyledButtonBase = React.forwardRef<
  HTMLButtonElement,
  IUnstyledButtonProps
>((props, ref) => <MantineUnstyledButton {...props} ref={ref} />);
UnstyledButtonBase.displayName = 'UnstyledButton';

/** @registry Design-layer pass-through over Mantine UnstyledButton; import this instead of @mantine/core UnstyledButton outside src/design. */
export const UnstyledButton = createPolymorphicComponent<
  'button',
  IUnstyledButtonProps
>(UnstyledButtonBase);
